import React, { useEffect } from 'react';
import {
  Routes,
  BrowserRouter as Router,
  Route,
  useLocation,
} from 'react-router-dom';
import Films from './components/Films';
import Books from './components/Books';
import { Home } from './components/Home';
import { Navbar } from './components/Navbar';
import Lenis from '@studio-freight/lenis';
import Footer from './components/Footer';

// Custom scroll wrapper to handle scroll on route change
function ScrollManager() {
  const location = useLocation();

  useEffect(() => {
    const lenis = new Lenis({
      smooth: true,
      lerp: 0.1,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    document.body.classList.add('lenis', 'lenis-smooth');

    return () => {
      lenis.destroy();
      document.body.classList.remove('lenis', 'lenis-smooth');
    };
  }, [location]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollManager />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/films" element={<Films />} />
        <Route path="/books" element={<Books />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
